export { default as lang } from './lang';

export {
  default as genders,
  ALL_GENDERS_VALUE,
  ALL_GENDERS_LIST,
} from './genders';
export { default as locales } from './locales';
export { default as voices } from './voices';
export {
  default as freetrials,
  FREE_TRIAL_NULL_VALUE,
  FREE_TRIAL_ELIGIBLE,
  FREE_TRIAL_INELIGIBLE,
} from './freetrials';

export { setFlags, getFlag } from './flags';

export { PLATFORMS } from './platforms';

export {
  UPLOADED_AUDIO,
  EXISTING_VOICEOVER,
  NEW_VOICEOVER,
  BG_MUSIC,
  DEFAULT_AUDIO,
  EXISTING_VO_BG_MUSIC,
} from './audioTypes';
export {
  UPLOADED_COVER_ART,
  UPLOADED_STATUS,
  UPLOADED_INFO,
  FILE_PROPERTIES,
  FILE_TYPE_PROP,
  FILE_SIZE_PROP,
  FILE_FAIL,
  IMAGE_DIMENSIONS,
  AUDIO_DURATION,
} from './uploadProperties';

export const MAX_FILE_SIZE_LIMIT = 104857600; // 100 mb
export const MAX_AUDIO_DURATION = 31;
export const CLIENT_AUDIO_TYPES = [
  'audio/ogg', // not supported by safari
  'audio/mp3',
  'audio/wav', // supported by chrome
  'audio/mpeg',
  'audio/x-wav', // supported by firefox, safari
];
export const CLIENT_IMAGE_TYPES = ['image/jpeg', 'image/png'];

export const COVER_ART_IMAGE_DIMENSIONS = { width: 640, height: 640 };

export const TOTAL_BUDGETS = [500, 1000, 1500];

export const MIN_BUDGET = 250;
export const MAX_BUDGET = 5000;

// Useful for production testing so that we don't have to get charged large amounts
// Note: String to avoid float representation issues
export const EASTER_EGG_BUDGET = '0.03';

export const WEBGATE_ENDPOINTS = {
  prod: 'https://spclient.wg.spotify.com',
  dev: 'https://exp.wg.spotify.com',
};

export const SPOTIFY_WEB_API = 'https://api.spotify.com/v1';

export const currencySymbols = {
  USD: '$',
};

export const PAGINATION_PAGE_LIMIT = 20;
export const HEADLINE_CHAR_LIMIT = 100;

// This must match backend user groups
export const USER_GROUPS = {
  INTERNAL: 'internal',
  PROMOTER: 'promoter',
  ADMIN: 'admin',
  MVP_USER: 'mvp_user',
};

export { SUPPORTED_BROWSER_VERSIONS } from './browsers';

export { CAMPAIGN_FORM_NAME, AUDIENCE_FORM_NAME } from './adCreation';



// WEBPACK FOOTER //
// ./src/config/index.js